import { IComponentController } from 'angular';
import { IAideTechniqueService } from '../../services/aide-technique.service';
import { IDonneesEnregistrementService } from '../../services/donnees-enregistrement.service';
import { IProfil } from '../../../../core/resources/profil.resource';

interface IToolbarHelpModel extends IComponentController {
    donneesEnregistrement: IDonneesEnregistrementService;
    aideTechnique: IAideTechniqueService;
    hasOutilsSupports: boolean;
}

export default function ToolbarHelperController(
    aideTechnique: IAideTechniqueService,
    donneesEnregistrement: IDonneesEnregistrementService,
    profil: IProfil,
) {
    const vm: IToolbarHelpModel = this;

    vm.aideTechnique = aideTechnique;
    vm.donneesEnregistrement = donneesEnregistrement;

    vm.$onInit = $onInit;

    function $onInit() {
        vm.hasOutilsSupports = profil.parametres.OUTILS_SUPPORT === 'OUI';
    }
}
